/**
 * 界面筛选固定枚举（与需求文档一致，用于多选；与 CSV 文案做包含 / 全等匹配）
 */

import type { GreenElectricityScale } from '../types';

/** 省级 / 待开发：绿电资源规模（与 JSON、`GreenElectricityScale` 文案一致；多选全等匹配） */
export const GREEN_ELECTRICITY_SCALE_OPTIONS: readonly GreenElectricityScale[] = [
  '600MW以下',
  '600MW~1000MW',
  '1000MW~1500MW',
  '1500MW~2000MW',
  '2000MW以上',
] as const;

export const NATIONAL_PROJECT_TYPE_OPTIONS: readonly string[] = [
  '风电',
  '光伏',
  '储能电站',
  '生物质热电联产',
  '绿电制氢氨醇',
  '污水/固废处理厂',
  '管廊及配套设施建设项目',
  '绿色交通体系',
  '绿色货运物流枢纽项目',
  '充电桩/加氢站项目',
  '智慧能碳电管理平台项目',
  '建筑节能降碳改造',
  '余热余冷梯级利用改造',
  '绿电专用输电通道/园区内部配网',
  '水资源利用',
  '园区新建建筑和厂房',
  '风、光、地热耦合供热系统',
] as const;

/** 省级 / 待开发园区综合能源消费量档位（与表格导出文案一致；筛选为单选全等匹配） */
export const COMPREHENSIVE_ENERGY_CONSUMPTION_OPTIONS: readonly string[] = [
  '15万吨以下',
  '15万~20万吨',
  '20万~100万吨',
  '100万吨以上',
] as const;

/** 待开发园区地区生产总值分档，单位：亿元 */
export const PENDING_GROSS_REGIONAL_PRODUCT_OPTIONS: readonly string[] = [
  '300亿元以下',
  '300亿~600亿元',
  '600亿~1000亿元',
  '1000亿~2000亿元',
  '2000亿元以上',
] as const;

/** 与 `provincialParks.json` 等产业类型文案一致；筛选为包含/全等匹配 */
export const PROVINCIAL_LEADING_INDUSTRY_OPTIONS: readonly string[] = [
  '新能源与绿色装备制造',
  '数字经济与算力 / 数据中心',
  '高端制造与先进装备',
  '生物医药与健康产业',
  '循环经济与资源再生',
  '出口导向性企业',
  '通用 / 专用设备制造',
  '电气机械和器材',
  '纺织、印染、皮革',
  '农副食品加工、食品',
  '化工类',
  '钢铁、金属冶炼类',
  '建材类',
  '橡胶、塑料加工类',
] as const;

/** 数据中偶发的产业别名 → 规范枚举文案 */
export const PROVINCIAL_LEADING_INDUSTRY_ALIASES: Readonly<Record<string, string>> =
  {
    '农副食品加工、食品制造': '农副食品加工、食品',
  };

export const NATIONAL_DOCKING_OPTIONS: readonly { label: string; value: '已对接' | '未对接' }[] =
  [
    { label: '已对接', value: '已对接' },
    { label: '未对接', value: '未对接' },
  ] as const;
